import URI from 'urijs';
import axios, { CancelTokenSource, CancelToken } from 'axios';
import { ActionContext } from 'vuex';

export interface ApiResult<T> {
    result: string;
    resultCode?: string;
    data?: T;
}

export const HTTP = axios.create({
    paramsSerializer: function(params: any) {
        let search = [];
        for (let k in params) {
            let v = params[k];
            if (v && Array.isArray(v)) {
                search.push(...v.map(x => `${k}=${encodeURIComponent(x)}`));
            }
            else {
                search.push(`${k}=${encodeURIComponent(v)}`);
            }
        }
        return search.join('&');
    }
});

function buildRequest(url: string, volatile: boolean, parameters?: any): any {
    let uri = url[0] == '/' ? new URI(window.location.toString()).pathname(url).search("") : new URI(url);
    let params = {};
    if (parameters) {
        for (let k in parameters) {
            if (k == '__volatile') {
                volatile = true;
            }
            else {
                params[k] = parameters[k];
            }
        }
    }
    if (volatile) {
        params['__t'] = new Date().getTime();
    }

    // Return ready to go Axios options.
    return { url: uri.toString(), params };
}

const discardableRequests: { [url: string]: CancelTokenSource } = {};

export function get(url: string, parameters?: any, isDiscardable = false) {
    let cts: CancelTokenSource;

    if (parameters === true || isDiscardable) {
        cts = discardableRequests[url];
        if (cts) {
            cts.cancel();
        }
        cts = discardableRequests[url] = axios.CancelToken.source();
    }

    return HTTP
        .request({ method: 'GET', cancelToken: cts && cts.token || null, ...buildRequest(url, true, parameters) })
        .catch((error: any) => {
            if (error.response.status == 401) {
               window.location.href = "/";
               return error.response;
            }
           throw error;
       });
}

export function getAsDataURL(url: string, parameters?: any): Promise<string> {
    return HTTP
        .request({ method: 'GET', responseType: 'blob', ...buildRequest(url, true, parameters) })
        .then(res => new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject
            reader.readAsDataURL(res.data)
        }))
        .catch((error: any) => {
            if (error.response.status == 401) {
               window.location.href = "/";
               return error.response;
            }
           throw error;
       });
}

export function post(url: string, data?: any) {
    return HTTP
        .request({ method: 'POST', data, ...buildRequest(url, false) })
        .catch((error: any) => {
             if (error.response.status == 401) {
                window.location.href = "/";
                return error.response;
             }
            throw error;
        });
}

export function del(url: string, parameters?: any) {
    return HTTP
        .request({ method: 'DELETE', ...buildRequest(url, false, parameters) })
        .catch((error: any) => {
            if (error.response.status == 401) {
               window.location.href = "/";
               return error.response;
            }
           throw error;
       });
}

export function checkResult(ctx: ActionContext<any,any>, result: ApiResult<void>): boolean;

export function checkResult<T>(ctx: ActionContext<any,any>, result: ApiResult<T>): T | false;

export function checkResult<T>(ctx: ActionContext<any,any>, result: ApiResult<T>) {
    if (result) {
        if (result.result == "OK") {
            return result.data || true;
        }
        else {
            if (result.result == "ERROR") {
                //ctx.dispatch('showError', result);
            }
        }
    }
    return false;
}


// WEBPACK FOOTER //
// ./src/dndg/helpers/api.ts